import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import ReactPlaceholder from 'react-placeholder/lib';
import Button from 'react-bootstrap/esm/Button';

const emptyReport = { head: [], body: [], excel: {} }

const normalizeReportData = (data = {}) => ({
    head: Array.isArray(data.head) ? data.head : [],
    body: Array.isArray(data.body) ? data.body : [],
    excel: data.excel ?? {},
})

const buildReportTable = (data, ready) => {
    if (!ready) {
        return ''
    }

    const { head: headRows, body: bodyRows } = normalizeReportData(data)

    if (!headRows.length) {
        return <p className="text-muted mb-0">No hay datos para mostrar.</p>
    }

    const head = headRows.map(r => ({
        name: r.toString().toLowerCase().replace(' ', '_'),
        text: r,
        align: 'center',
    }))

    const rowsBody = bodyRows.map(b => {
        const rowFormat = {}
        head.forEach((h, i) => {
            rowFormat[h.name] = b?.[i]
        })
        return rowFormat
    })

    return <ReactDataTableBootstrap
        head={[head]}
        rows={rowsBody}
        pageLength={100}
    />
}

const SaleProductsQtyPrice = _ => {
    const [ready, setReady] = useState(false)
    const [rows, setRows] = useState(emptyReport)
    const [rowsPrice, setRowsPrice] = useState(emptyReport)
    const [reporteQty, setReportQty] = useState({})
    const [reportePrice, setReportPrice] = useState({})

    useEffect(() => {
        Promise.all([
            Controllers.sale.get_sale_product_qty(),
            Controllers.sale.get_sale_product_price()
        ]).then(res => {
            const qtyData = normalizeReportData(res?.[0]?.data)
            const priceData = normalizeReportData(res?.[1]?.data)

            setRows(qtyData)
            setRowsPrice(priceData)
            setReportQty({
                excel: qtyData.excel?.file,
                filename: qtyData.excel?.filename,
            })
            setReportPrice({
                excel: priceData.excel?.file,
                filename: priceData.excel?.filename,
            })
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setReady(true)
            })
    }, [])

    const dtRows = useMemo(() => buildReportTable(rows, ready), [rows, ready])

    const dtRows2 = useMemo(() => buildReportTable(rowsPrice, ready), [rowsPrice, ready])

    return <>
        <Card className="mb-4">
            <Card.Header className="justify-content-between">
                <span>Ventas Totales por Producto y Cantidad</span>
            </Card.Header>
            <Card.Body>
                <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
                    {reporteQty?.filename && <div className='mb-4'>
                        <a href={reporteQty?.excel} download={reporteQty?.filename}>
                            <Button size="sm" variant="success">
                                <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                            </Button>
                        </a>
                    </div>}
                    {dtRows}
                    {/* <div className="table-responsive">
                        <table className="table table-sm table-hover table-striped table-bordered">
                            <thead>
                                <tr>
                                    {React.Children.toArray(rows?.head?.map(h => <th>{h}</th>))}
                                </tr>
                            </thead>
                            <tbody>
                                {React.Children.toArray(rows?.body?.map(h => {
                                    let td = []
                                    for (let i = 0; i < h.length; i++) {
                                        td.push(<td align="center">{h[i]}</td>)
                                    }

                                    return <tr>
                                        {React.Children.toArray(td)}
                                    </tr>
                                }))}
                            </tbody>
                        </table>
                    </div> */}
                </ReactPlaceholder>
            </Card.Body>
        </Card>
        <Card className="mb-4">
            <Card.Header className="justify-content-between">
                <span>Ventas Totales por Producto y Precio</span>
            </Card.Header>
            <Card.Body>
                <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
                    {reportePrice?.filename && <div className='mb-4'>
                        <a href={reportePrice?.excel} download={reportePrice?.filename}>
                            <Button size="sm" variant="success">
                                <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                            </Button>
                        </a>
                    </div>}
                    {dtRows2}
                    {/* <div className="table-responsive">
                        <table className="table table-sm table-hover table-striped table-bordered">
                            <thead>
                                <tr>
                                    {React.Children.toArray(rowsPrice?.head?.map(h => <th>{h}</th>))}
                                </tr>
                            </thead>
                            <tbody>
                                {React.Children.toArray(rowsPrice?.body?.map(h => {
                                    let td = []
                                    for (let i = 0; i < h.length; i++) {
                                        td.push(<td align="center">{h[i]}</td>)
                                    }

                                    return <tr>
                                        {React.Children.toArray(td)}
                                    </tr>
                                }))}
                            </tbody>
                        </table>
                    </div> */}
                </ReactPlaceholder>
            </Card.Body>
        </Card>
    </>
}

export default SaleProductsQtyPrice